import React from "react";
import { notification } from "antd";

const notificationStyle = {
  boxShadow: "0px 10px 40px rgba(23, 63, 112, 0.1)",
  borderRadius: "2rem",
};

notification.config({
  placement: "bottomRight",
  duration: 0,
});

export const createSuccessNotification = (description: string) => {
  notification.success({
    message: "Sucesso!",
    description: description,
    placement: "bottomRight",
    style: notificationStyle,
    duration: 5,
  });
};

let lastMessageAt: number;
let lastMessage: string;

export const createErrorNotification = (description: string) => {
  if (description === lastMessage && (lastMessageAt + 3000) >= +new Date())
    return;

  lastMessageAt = +new Date() + 3000;
  lastMessage = description;

  notification.error({
    message: "Erro!",
    description: description,
    placement: "bottomRight",
    style: notificationStyle,
    duration: 5,
  });
};
